import React from 'react';
import Axios from 'axios';
import APP_CONFIG from '../config';
import { notification } from 'antd';

const _url=`${APP_CONFIG.network.base_url}/job`;
const TIMEOUT_DATA_CODE="TIMEOUT";
const TIMEOUT_NODATA_CODE="TIMEOUT_NODATA";

const FINAL_DATA_CODE="FINAL";
const DEFAULT_TIMEOUT=10*60*1000;
const DEFAULT_INTERVAL=2000;



const defaultConditionChecker=(data)=>{
    console.log("DEFAULT",data);
    if(data.total==null||data.current===data.total){
        return true
    }
    return false;
}


class PollingServices {
    constructor(context,stateKey,stopCondition,url) {
       
        this.ctx=context;
        this.stateKey=stateKey||"progress";
        this.stopCondition=stopCondition||defaultConditionChecker;
        this.state = {};
        this.manualEndConnection=false;
        this.withAuth=true;
        this._url=`${APP_CONFIG.network.base_url}${url}`;


        this.pausedEvent={};
        let auth_data=localStorage.getItem('adminAuth');
        if(!auth_data){
            auth_data="{}"
        }
        this.auth_detail=JSON.parse(auth_data);
        console.log("AUTH DATA",this.auth_detail);


        this.callAPI=this.callAPI.bind(this);
        this.startPolling=this.startPolling.bind(this);
        this.pausePolling=this.pausePolling.bind(this);
        this.resumePolling=this.resumePolling.bind(this);
    };

    callAPI=async(url)=>{
        let res = await Axios.get(this._url);
        console.log("res is",res.data.data)
        return res.data.data;
    }

    startPolling=(eventName,Key,Interval,Timeout)=>{
        let event_name=eventName;
        let key=Key;
        let endTime=Number(new Date()) + (Timeout||DEFAULT_TIMEOUT);
        let interval=Interval||DEFAULT_INTERVAL;
        let ctx=this;
        let errorCount=0;
        let max_errorCount=10;

        let {access_token,refresh_token}=this.auth_detail;
        console.log("ACCESS TOKER",access_token,this.auth_detail.access_token)


    var checkCondition = function(resolve, reject) {
        // If the condition is met, we're done! 
        let isTimeoutExceeded=(Number(new Date()) > endTime);

        // Checking for single polling service
        if(ctx.manualEndConnection){
            console.log("Paused connection")
            if(isTimeoutExceeded){
                console.log("TIMEOUT DURING PAUSE ")
                resolve({
                    event_name:eventName,
                    key_name:Key,
                    type:TIMEOUT_NODATA_CODE,
                    data:null
                });
                return;
            }
            setTimeout(checkCondition, interval, resolve, reject);
            return;
        }

        // Checking for each event
        if(ctx.pausedEvent[eventName]){
            // Paused event
            console.log("Paused connection for event",eventName)
            if(isTimeoutExceeded){
                console.log("TIMEOUT DURING PAUSE ")
                resolve({
                    event_name:eventName,
                    key_name:Key,
                    type:TIMEOUT_NODATA_CODE,
                    data:null
                });
                return;
            }
            setTimeout(checkCondition, interval, resolve, reject);
            return;
        }
        Axios.get(ctx._url,{
            headers:{
                Authorization:`Bearer ${access_token}`
            }
        })
        .then((result)=>{
            let {data}=result.data||{};
            console.log("is timeout",isTimeoutExceeded,endTime,Number(new Date()))
            let isConditionMet=false;
            let _message=data.message||{};
            let not_type = 'warning';
            let errors=[];
            if(Array.isArray(_message.error_message)&&_message.error_message.length>0){
                errors.push(
                        <h4
                            style={{
                            textDecorationLine: 'underling'
                        }}>Errors</h4>
                    );
                    _message
                        .error_message
                        .map((item) => {
                            errors.push(
                                <p
                                    style={{
                                    color: 'red',
                                    margin: 0
                                }}>{item}</p>
                            );
                        });
                isConditionMet=true;
            }else{
                not_type='success'
            }
            if(data.total==null||data.total===data.current){
                isConditionMet=true;
            }

            if(typeof ctx.stopCondition==='function'){
                isConditionMet=ctx.stopCondition(data,Key);
                console.log(`%c checking condition ${eventName} `,'color:#1890ff;font-size:20px;background:#d5d7de',isConditionMet,data);
            }
            
            if(isConditionMet){
                console.log("%c Final Resolved",'color:#52c41a;font-size:20px',data)
                notification.open({
                    message: "Processing completed", 
                    type: not_type, 
                    description: errors.length>0?errors:'Success',
                    duration: 0
                    });
                resolve({
                    key_name:Key,
                    event_name:eventName,
                    type:FINAL_DATA_CODE,
                    data:data
                });
                return;
            }
            // else if(!isConditionMet && isTimeoutExceeded ){
            //     console.log("%c Timeout Resolved",'color:#f5222d;font-size:20px',data)
            //     resolve({
            //         key_name:Key,
            //         event_name:eventName,
            //         type:TIMEOUT_DATA_CODE,
            //         data:data
            //     });
            //     return;
            //     // repeat polling again
            // }
            else if(!isConditionMet&&!isTimeoutExceeded){
                setTimeout(checkCondition, interval, resolve, reject);
            }


        })
        .catch((error)=>{
            console.log("rejected timeout");
            errorCount+=1;
            if(errorCount<max_errorCount){
            setTimeout(checkCondition, interval, resolve, reject);
            }else{
                notification.open({
                    message: "Processing failed", 
                    type: 'error', 
                    description: 'Failed to get status of Process',
                    
                    });
            reject({
                key_name:Key,
                event_name:eventName,
                type:"Multiple Connection Failure",
                error:error
            });
        }
        })        
    };

    return new Promise(checkCondition);
    
    }


    pausePolling=()=>{
        console.log("PAUSED POLLING")
        this.manualEndConnection=true;
    }

    resumePolling=()=>{
        console.log("RESUMED POLLING")
        this.manualEndConnection=false;
    }

    pauseEvent=(eventName)=>{
        this.pausedEvent={...this.pausedEvent,[eventName]:true}
    }

    resumeEvent=(eventName)=>{
        delete this.pausedEvent[eventName]
    }

    

}

export {PollingServices}